export default __webpack_public_path__ + "static/media/no.60b65aa5.png";